import isOS from './functions/_isOS'

if (isOS == 'ios') {
  const notIos = document.querySelectorAll('.not-ios')
  if (notIos.length > 0) {
    notIos.forEach((item) => {
      item.remove()
    })
  }
}
